function decrement(id, minus) {
    var badgeCount = parseInt($('#' + id).find('.badge').html());
    badgeCount -= minus;
    updateNavBadge(id, badgeCount);
}

function updateNavBadge(item, count) {
    var $badge = $('#'+ item).find('.badge');
    if (count) {
        $badge.html(count);
    } else {
        $badge.fadeOut();
    }
}

module.exports.decrement = decrement;
module.exports.updateNavBadge = updateNavBadge;
